export default class Utils {
    public static delay(timeInMs: number) {
        return new Promise(resolve => setTimeout(resolve, timeInMs))
    }
}